import ArticleCard from './articleCard.component';

export default ArticleCard;
